import React, { useEffect, useState } from 'react';
import FormField from 'components/Form/FormField';
import Filters from 'components/Filters/Filters';
import { TenantsFilter, useTenantsContext } from '../tenants.context';

const TenantsFilters = () => {
  const { tenantsFilter, setTenantsFilter } = useTenantsContext();
  const [filters, setFilters] = useState(tenantsFilter);

  useEffect(() => {
    setFilters(tenantsFilter);
  }, [tenantsFilter]);

  const handleChangeField = (
    value: string | number | number[] | boolean | undefined,
    key: keyof TenantsFilter
  ) => {
    if (Array.isArray(value) && !value.length) {
      setFilters({ ...filters, [key]: [] });
    } else {
      setFilters({ ...filters, [key]: value });
    }
  };

  const clearFilters = () => setTenantsFilter({});

  const filterInputs = [
    <FormField
      field={{
        label: 'Filter by name',
        value: filters.name,
        containedLabel: true,
        onChange: () => {},
        fieldProps: {
          size: 'small',
        },
      }}
      onChange={(searchText) => handleChangeField(searchText, 'name')}
      key='name'
    />,
    <FormField
      field={{
        label: 'Store State Name',
        value: filters.storeStateName,
        containedLabel: true,
        onChange: () => {},
        fieldProps: {
          size: 'small',
        },
      }}
      onChange={(storeStateName) => handleChangeField(storeStateName, 'storeStateName')}
      key='storeStateName'
    />,
  ];

  const hasFilters = !!Object.entries(filters).find(
    (filter) => filter[0] !== 'tenantId' && (filter[1]?.length || filter[1] > 0)
  );

  return (
    <Filters
      filterInputs={filterInputs}
      onApplyFilters={() => setTenantsFilter(filters)}
      onClearFilters={clearFilters}
      hasFilters={hasFilters}
    />
  );
};

export default TenantsFilters;
